import React, { useState, useEffect } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { trackPageView } from '../util/Analytics.jsx';
import Utils from '../util/Utils.jsx';

import { useStateValue } from '../context/state.jsx';
import { setTokenExpired } from '../context/token.js';
import { setLoginSucceeded } from '../context/loginSucceeded.js';

const VerifyPage = () => {
	const [message, setMessage] = useState('');
	const [redirectTo, setRedirectTo] = useState(null);
	const [, dispatch] = useStateValue();
	const { Token } = useParams();

	useEffect(() => {
		trackPageView();

		if (Token) {
			setMessage('Verifying...');
			Utils.ajax('verify', { Token }, dispatch, result => {
				if (result.success) {
					Utils.allowAuth();
					localStorage.setItem('token', result.Token);
					dispatch(setTokenExpired(false));
					dispatch(setLoginSucceeded(true));
					if (result.alreadyVerified) {
						setMessage('Your account has already been verified.');
					} else {
						setMessage('Your account is now verified!');
					}
					if (result.datasetId) {
						setRedirectTo(`/app/dataset/${result.datasetId}`);
					}
				}
			});
		} else {
			setMessage('Bad verification link or link has expired.');
		}
	}, []);

	if (redirectTo) {
		return (<Navigate to={redirectTo} replace />);
	}

	return (
		<div className="verifyPage">
			<div className="pageContent">
				<div className="verifyMessage">
					<h2>
						{message}
						{!redirectTo && (
							<div className="agreement">
								<Link className="underline blueLink" to="/signin/">Get Started Using SiteWalker</Link>
							</div>
						)}
					</h2>
				</div>
			</div>
		</div>
	);
};

export default VerifyPage;
